type Props = {
  n: number | string
}

export default function StepCircle({ n }: Props) {
  return <div className="step-number">{n}</div>
}
